/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready () {
            // console_log(
            //     'App is being served from cache by a service worker.\n' +
            //         'For more details, visit https://goo.gl/AFskqB'
            // )
        },
        cached () {
            // console_log('Content has been cached for offline use.')
        },
        updated () {
            // console_log('New content is available; please refresh.')
        },
        offline () {
            // console_log('No internet connection found. App is running in offline mode.')
        },
        error () {
            // console_error('Error during service worker registration:', error)
        }
    })
}
